<script setup>
  import { defineAsyncComponent, onMounted } from 'vue';
  import { useRoute } from 'vue-router';

  import HomeCta from '@/components/home/HomeCta.vue';
  import HomeFaq from '@/components/home/HomeFaq.vue';
  import HomeFooter from '@/components/home/HomeFooter.vue';
  import HomeHero from '@/components/home/HomeHero.vue';
  import HomeHowItWorks from '@/components/home/HomeHowItWorks.vue';
  import HomeNavbar from '@/components/home/HomeNavbar.vue';
  import HomeSeePrice from '@/components/home/HomeSeePrice.vue';
  import HomeVideo from '@/components/home/HomeVideo.vue';
  import HomeWhy from '@/components/home/HomeWhy.vue';

  import useAddressEntry from '@/composables/useAddressEntry';
  import { HOME_NAVBAR } from '@/constants/home';

  // the only user of Swiper: its own chunk
  const HomeWhoInstalls = defineAsyncComponent(
    () => import('@/components/home/HomeWhoInstalls.vue')
  );

  const { openAddressEntry } = useAddressEntry();

  // Who Installs loads async and shifts the sections below it: wait for all of them
  const SECTIONS_WAIT_MS = 3000;

  const route = useRoute();

  const waitForSections = () =>
    new Promise((resolve) => {
      const startedAt = performance.now();
      const check = () => {
        const isReady = HOME_NAVBAR.links.every(({ id }) => document.getElementById(id));
        if (isReady || performance.now() - startedAt > SECTIONS_WAIT_MS) resolve();
        else requestAnimationFrame(check);
      };
      check();
    });

  onMounted(async () => {
    if (!route.hash) return;
    await waitForSections();
    document.getElementById(route.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
  });
</script>

<template>
  <div
    class="text-charcoal-blue font-montserrat flex w-full flex-col items-center bg-white antialiased"
  >
    <HomeNavbar />
    <HomeHero @get-price="openAddressEntry" />
    <HomeWhy @get-price="openAddressEntry" />
    <HomeHowItWorks @get-price="openAddressEntry" />
    <HomeVideo />
    <HomeSeePrice @get-price="openAddressEntry" />
    <HomeWhoInstalls />
    <HomeFaq />
    <HomeCta @get-price="openAddressEntry" />
    <HomeFooter with-top-divider />
  </div>
</template>
